import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=f8e7e862&scoped=true&"
import script from "./ProjectDescription.vue?vue&type=script&lang=js&"
export * from "./ProjectDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=f8e7e862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e7e862",
  null
  
)

export default component.exports